import { render, staticRenderFns } from "./LabourRateList.vue?vue&type=template&id=625fc4fe"
import script from "./LabourRateList.vue?vue&type=script&lang=ts"
export * from "./LabourRateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports